<template>
    <div class="c-client-detail">
        <SphereNavigation color="blue" selected="client-search" />

        <div class="inner-content">
            <h1>{{$t('client_detail.title')}}</h1>

            <div class="list">
                <div v-for="client in clients" :key="client.id" class="list--item" @click.prevent="showFiche(client)">
                    <span class="left">
                        <span class="date">
                            {{formatDateString(client.measurement_date)}}
                        </span>
                        <span class="name">
                            {{client.firstname}} {{client.lastname}}
                        </span>
                        <span class="email">
                            {{client.email}}
                        </span>
                    </span>
                    <span class="right">
                        <span v-if="client.ergosleep_id != null" class="btn-round black">
                            <img src="/img/icon-view.svg" />
                        </span>
                        <span v-else>
                            {{$t('client_detail.no_measurement_result')}}
                        </span>
                    </span>
                </div>
                <div v-if="clients.length == 0" class="no-results">
                    {{$t('client_detail.no_results')}}
                </div>
            </div>
            <div>
                <button class="btn-basic bordered btn-reset" type="submit" @click.prevent="backToSearch">
                    {{$t('client_detail.search_other')}}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import SphereNavigation from "@/components/app/SphereNavigation.vue";
import {formatDate, newDateFromString} from "@/utils/utils.js";
import {apiStore} from "@/stores/api.js";

export default {
    name : "ClienSearch",
    components : {
        SphereNavigation
    },

    data() {
        return {
            clients : []

        };
    },

    async created() {
        this.clients = apiStore().clientSearchResult;
        if (!this.clients) {
            this.$router.push({name: "client-search"});
        } else {
            this.clients.sort((a, b) => {
                return newDateFromString(b.measurement_date) - newDateFromString(a.measurement_date);
            });
        }
    },

    methods: {
        backToSearch() {
            this.$router.go(-1);
        },

        showFiche(client) {
            if (client.ergosleep_id !== null) {
                this.$router.push({name: "client-detail", params: {ergosleep_id: client.ergosleep_id}});
            }
        },

        formatDateString(date) {
            if (!date) return "";

            return formatDate(newDateFromString(date));
        }
    }
};
</script>

<style lang="scss" scoped>
    .c-client-detail {
        height : 100%;

        .inner-content {
            padding-left: 45%;
            padding-top : 3%;
        }

        .btn-reset {
            @include slideIntroAnimation(basicSlideIntro, 450ms, 50ms);
        }

        .no-results {
            margin-bottom: 2rem;
        }

        .list--item {
            .name {
                margin: 0 0.5rem;
            }
            .email {
                color : #999999;
            }

            .left {
                margin-left : 1rem;
            }
            .right {
                margin-right : 1rem;
            }
        }

        .list {
            height : 55vh;
        }
    }
</style>